'use strict';

/* Dependencies */
var React = require('react/addons');
var cx = React.addons.classSet;

/* Actions */
var TranslationEditorActions = require('actions/translation-editor');

var Modal = React.createClass({
  displayName: 'Modal',

  render: function render() {
    var props = this.props;

    var classes = {};
    classes['modal-component'] = true;
    classes[props.className] = true;

    return React.createElement(
      'div',
      {
        className: cx(classes),
        onClick: this.props.onCancel },
      React.createElement(
        'form',
        {
          className: 'content-wrapper',
          onSubmit: props._onSubmit,
          onClick: this._onClick },
        props.children
      )
    );
  },

  _onSubmit: function _onSubmit(evt) {
    evt.preventDefault();

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
  },

  _onClick: function _onClick(evt) {
    evt.stopPropagation();
  }
});

module.exports = Modal;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/modal.js
 **/